module.exports = __webpack_public_path__ + "c524e08b97692e736ce43043455b137d.svg";